module.exports = __webpack_public_path__ + "img/logo_team23.b37d5910.svg";